<template>
  <v-card>
    <v-toolbar color="primary" class="text-white rounded-0" height="80px">
      <v-toolbar-title class="ml-3">
        <h2>Arama Sonuç Kodları</h2>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :hide-details="true"
            v-model="dateRangeText"
            style="width: 100%; max-width: 220px"
            label="Tarih Aralığı"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            dark
            range
          ></v-text-field>
        </template>
        <v-date-picker v-model="rangeDates" range>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(date)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
      <KTTopMenu />
    </v-toolbar>
    <v-row>
      <v-col cols="12">
        <h3
          class="text-h6 font-weight-bold my-4 text-center d-flex justify-content-center align-items-center"
        >
          Ana Sonuç Kodları
          <v-icon
            small
            class="ml-2"
            @click="showMainTable = !showMainTable"
            style="cursor: pointer"
          >
            {{ showMainTable ? "mdi-eye" : "mdi-eye-off" }}
          </v-icon>
        </h3>
        <v-data-table
          v-if="showMainTable"
          :headers="headers"
          :items="resultCodeData"
          :loading="loading"
          :items-per-page="100"
          item-key="id"
          class="border-y"
        >
          <template #item.call_result="{ item }">
            <span>{{ item.call_result }}</span>
          </template>
          <template #item.lead_count="{ item }">
            <span>{{ item.lead_count }}</span>
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="12">
        <h3
          class="text-h6 font-weight-bold my-4 text-center d-flex justify-content-center align-items-center"
        >
          Alt Sonuç Kodları
          <v-icon
            small
            class="ml-2"
            @click="showSubTable = !showSubTable"
            style="cursor: pointer"
          >
            {{ showSubTable ? "mdi-eye" : "mdi-eye-off" }}
          </v-icon>
        </h3>
        <v-data-table
          v-if="showSubTable"
          :headers="subTableHeaders"
          :items="newSubResultCodeData"
          :loading="loading"
          :items-per-page="100"
          item-key="id"
          class="border-top"
          :item-class="getRowClass"
        >
          <template #item.call_result="{ item }">
            <span v-if="item.call_result" class="font-weight-bold">{{
              item.call_result
            }}</span>
          </template>

          <template #item.sub_call_result="{ item }">
            <span>{{ item.sub_call_result }}</span>
          </template>

          <template #item.lead_count="{ item }">
            <span>{{ item.lead_count }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import AxiosInstance from "@/core/services/axios.service";
import KTTopMenu from "@/view/layout/header/TopMenu.vue";
import moment from "moment";

export default {
  name: "CallResultCodesReport",
  components: { KTTopMenu },
  data() {
    return {
      resultCodeData: [],
      subResultCodeData: [],
      menu: false,
      loading: false,
      showMainTable: true,
      showSubTable: true,
      rangeDates: [
        moment().subtract(1, "month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      headers: [
        {
          value: "call_result",
          text: "Sonuç Kodu",
          align: "left",
        },
        { value: "lead_count", text: "Lead Sayısı", align: "center" },
      ],
      subTableHeaders: [
        {
          value: "call_result",
          text: "Sonuç Kodu",
          align: "left",
        },
        {
          value: "sub_call_result",
          text: "Alt Sonuç Kodu",
          align: "left",
        },
        { value: "lead_count", text: "Lead Sayısı", align: "center" },
      ],
      groupColors: [
        "#f0f9ff",
        "#e0f7fa",
        "#f1f8e9",
        "#fff8e1",
        "#fce4ec",
        "#f3e5f5",
      ],
    };
  },
  mounted() {
    this.fetchCallResultCodesReport();
  },
  methods: {
    async fetchCallResultCodesReport() {
      this.loading = true;

      const [start_date, end_date] = this.rangeDates;

      try {
        const { data } = await AxiosInstance.get("reports/result-codes", {
          params: {
            start_date,
            end_date,
          },
        });
        this.resultCodeData = data.result_codes;
        this.subResultCodeData = data.sub_result_codes;
      } catch (error) {
        this.$toast.error(
          "Rapor verisi alınamadı:",
          error?.response?.data || error
        );
        this.resultCodeData = [];
        this.subResultCodeData = [];
      } finally {
        this.loading = false;
      }
    },
    getRowClass(item) {
      return {
        "custom-colored-row": true,
        [`group-${item.groupColor.replace("#", "")}`]: true,
      };
    },
  },
  computed: {
    dateRangeText() {
      return this.rangeDates.join(" -- ");
    },
    newSubResultCodeData() {
      return this.subResultCodeData.flatMap((result, groupIndex) => {
        return result.sub_results.map((sub, index) => ({
          call_result: index === 0 ? result.result_code : "",
          sub_call_result: sub.sub_result_code,
          lead_count: sub.lead_count,
          groupColor: this.groupColors[groupIndex % this.groupColors.length],
        }));
      });
    },
  },
  watch: {
    rangeDates: {
      handler() {
        if (
          this.rangeDates.length === 2 &&
          this.rangeDates[0] &&
          this.rangeDates[1]
        ) {
          this.fetchCallResultCodesReport();
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.group-f0f9ff {
  background-color: #f0f9ff;
}
.group-e0f7fa {
  background-color: #e0f7fa;
}
.group-f1f8e9 {
  background-color: #f1f8e9;
}
.group-fff8e1 {
  background-color: #fff8e1;
}
.group-fce4ec {
  background-color: #fce4ec;
}
.group-f3e5f5 {
  background-color: #f3e5f5;
}
</style>
